export const getCookie = (cookieName: string) => {
  const cookies = document.cookie.split(';').map((cookie) => cookie.trim());
  for (const cookie of cookies) {
    const [name, value] = cookie.split('=');
    if (name === cookieName) return value;
  }
};

export const setCookie = (
  name: string,
  value: string,
  daysToExpire?: number,
) => {
  const expires = daysToExpire
    ? '; expires=' + new Date(Date.now() + daysToExpire * 864e5).toUTCString()
    : '';
  document.cookie =
    name + '=' + encodeURIComponent(value) + expires + '; path=/';
};
